import { Component, OnInit } from "@angular/core";
import { AppProperties } from "app/CognianModels/AppProperties";
import { Router } from "@angular/router";
import { CogAuthService } from "app/CognianServices/cog-auth.service";
import { UserRegRights } from "app/CognianModels/User.Model";
import { DomSanitizer } from "@angular/platform-browser";
import * as myGlobals from "environments/globals";

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  allowedUsers: UserRegRights[];
  isVisible: boolean;
  groupName: String;
}
export const ROUTES: RouteInfo[] = [
  // { path: '/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
  {
    path: "/newsfeed",
    title: "News Feed",
    icon: "library_books",
    class: "",
    allowedUsers: [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  {
    path: "/academic",
    title: "School Papers",
    icon: "assignment",
    class: "",
    allowedUsers: [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  {
    path: "/cognianacademics",
    title: "Cognian Resources",
    icon: "bubble_chart",
    class: "",
    allowedUsers: [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },

  // { path: '/academic2', title: 'School Resources',  icon:'menu_book', class: '' },

  // {
  //   path: "/examination",
  //   title: "Create Class Test",
  //   icon: "assessment",
  //   class: "",
  //   allowedUsers: [
  //     UserRegRights.Teacher,
  //     UserRegRights.DepartmentHead,
  //     UserRegRights.SysAdmin,
  //   ],
  //   isVisible: false,
  //   groupName: "none",
  // },
  {
    path: "/main-exam",
    title: "Class Tests",
    icon: "assessment",
    class: "",
    allowedUsers: [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  {
    path: "/lessons",
    title: "Class Lessons",
    icon: "account_balance",
    class: "",
    allowedUsers:  [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  {
    path: "/schoolresource",
    title: "View All School Resources",
    icon: "descriptiont",
    class: "",
    allowedUsers:  [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  {
    path: "/upload",
    title: "Upload Resource",
    icon: "cloud_upload",
    class: "",
    allowedUsers: [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  {
    path: "/user-profile",
    title: "My Profile",
    icon: "person",
    class: "",
    allowedUsers: [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  {
    path: "/calendar",
    title: "School Calendar",
    icon: "date_range",
    class: "",
    allowedUsers: [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  {
    path: "/cloud-storage",
    title: "School Cloud Storage",
    icon: "backup",
    class: "",
    allowedUsers: [UserRegRights.All],
    isVisible: false,
    groupName: "none",
  },
  // { path: '/table-list', title: 'Table List',  icon:'content_paste', class: '' },
  // { path: '/typography', title: 'Typography',  icon:'library_books', class: '' },
  // { path: '/icons', title: 'Icons',  icon:'bubble_chart', class: '' },
  // { path: '/maps', title: 'Maps',  icon:'location_on', class: '' },
  // { path: '/notifications', title: 'Notifications',  icon:'notifications', class: '' },
  // { path: '/upgrade', title: 'Upgrade to PRO',  icon:'unarchive', class: 'active-pro' },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  menuGroups = [
    {
      name: "none",
      icon: "",
      visible: false,
    },
    {
      name: "Test",
      icon: "",
      visible: false,
    },
  ];
  menuItems: any[];
  user: string;
  schoolName: string;
  imagePath: any;
  constructor(
    private _sanitizer: DomSanitizer,
    private appdata: AppProperties,
    private router: Router,
    private auth: CogAuthService
  ) {}

  ngOnInit() {
    
    if (this.appdata.school.SchoolLogo.FileName)
      this.imagePath = this._sanitizer.bypassSecurityTrustUrl(
        "data:image/" +
          this.appdata.school.SchoolLogo.extension.slice(1) +
          ";base64," +
          this.appdata.school.SchoolLogo.ContentBase64
      );
    else {
      this.imagePath = myGlobals.appLogo;
    }
    // let approvedMenuItems;
    // ROUTES.forEach(c=>
    //   {
    //     if(c.allowedUsers.filter(d=>d == UserRegRights.All))//Everyone is allowed to see this
    //     {
    //       approvedMenuItems =
    //     }
    //   });
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.user = localStorage.getItem("UserName");
    this.schoolName = this.appdata.school.SchoolName;
    this.menuItems = this.menuItems.filter(
      (c) =>
        c.allowedUsers.indexOf(this.appdata.loggedInUser.Rights) != -1 ||
        c.allowedUsers.indexOf(UserRegRights.All) != -1
    );
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  logUserOut() {
    this.auth.Logout();
    this.router.navigate(["/login"]);
  }
}
